import _ from 'lodash';
import { simplePopupFactory } from 'shared/simple_popups/simplePopupFactory';
import addMediaFromFolderPopup from './addMediaFromFolderPopup';

/**
 * Lets the user pick media they already have.
 *
 * @param callback       receives the list of picked media items
 * @param filter         one of 'audio', 'image', 'document', 'video', 'folder'
 * @param limit          how many items may be picked, 1...~8
 * @param cancelCallback called instead when the popup is dismissed
 */
export function addMediaFromFolder (callback, filter, limit, cancelCallback = _.noop) {
    const { vm, popupComponent, fEl } = simplePopupFactory.mount_vue_popup(addMediaFromFolderPopup);
    popupComponent.show(filter, limit)
        .then(res => {
            callback(res);
        }, cancel => {
            cancelCallback();
        })
        .finally(() => {
            fEl?.focus();
            vm?.$destroy();
        });
}

export default addMediaFromFolder;
